import {FlowType} from './state/Flow';

export class FlowMetaData {
  flowId: string;
  flowName: string;
  directory: string;
  flowStatus: string;
  flowType: FlowType;

  constructor(flowId: string, flowName: string, directory: string, flowStatus: string = null, flowType = null) {
    this.flowId = flowId;
    this.flowName = flowName;
    this.directory = directory;
    this.flowStatus = flowStatus;
    this.flowType = flowType;
  }
}
